<template>
  <div class="nolo-calls-outer-container">
    <div class="nolo-calls-border-red">
      <div class="nolo-calls-border-orange">
        <div class="nolo-calls-border-yellow">
          <div
            v-for="(name, index) in callList"
            :key="name" class="name-class"
            :class=" index == callList.length - 1 ? '' : 'name-underline'">
            {{ name }}
            <span v-if="name.length == 0"
                  class="icon"
                  style="color: pink"
                  key="nameLoader">
              <i class="fas fa-spinner fa-pulse"/>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div style="padding-top: 5px" class="align-input-stuff">
      <input
        class="input is-small"
        type="password"
        placeholder="xxxxx"
        style="width: 48px"
        v-model="userInput"
        v-on:keyup.enter="updateCalls"/>
      <span v-if="!isUpdating"
            class="icon icon-border"
            v-on:click="updateCalls"
            key="normalState">
        <i class="fas fa-skull-crossbones"/>
      </span>
      <span v-if="isUpdating"
            class="icon icon-border"
            key="updatingState">
        <i class="fas fa-spinner fa-pulse"/>
      </span>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'NoloCalls',
    data() {
      return {
        callList: ["","","","",""],
        isUpdating: false,
        userInput: ""
      }
    },
    methods: {
      updateCalls() {
        /* eslint-disable no-console */
        this.isUpdating = true;
        let trackUrl = 'https://noi3mg9y29.execute-api.us-east-1' +
          '.amazonaws.com/prod/updateCallList';
        this.axios
          .post(trackUrl, {"userInput": this.userInput})
          .then(response => {
            this.callList = response.data.response;
          })
          .catch(error => { console.log(error) })
          .finally(() => { this.isUpdating = false })
        /* eslint-disable no-console */      }
    },
    mounted() {
      /* eslint-disable no-console */
      let trackUrl = 'https://noi3mg9y29.execute-api.us-east-1' +
        '.amazonaws.com/prod/getCallList';
      this.axios
        .get(trackUrl, {"userInput": this.userInput})
        .then(response => {
          console.log(response.data);
          this.callList = response.data.response;
        })
        .catch(error => { console.log(error) })
      /* eslint-disable no-console */
    }
  }
</script>
<style scoped>
  .nolo-calls-outer-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    min-height: 12px;
  }
  .nolo-calls-border-red { border: dotted red 2px; }
  .nolo-calls-border-orange { border: dotted orange 2px; }
  .nolo-calls-border-yellow {
    border: dotted yellow 2px;
    min-width: 150px;
  }
  .name-underline {
    border-bottom: powderblue solid 1px;
  }
  .name-class {
    padding: 5px;
    margin: 0 5px;
  }
  .icon-border {
    border: black solid 1px;
    border-radius: 15%;
    color: black;
    margin-left: 5px;
  }
  .align-input-stuff {
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
